import * as Yup from "yup";
import { campo_obligatorio, email_invalido } from "../../utils/traductor";
import {
  getNombre,
  getApellido,
  getemail,
  getIdioma,
  getTelefono,
  getIdentificacion,
  getContactosEmergencia,
  getavatar,
} from "../../utils/variablesLocales";

export function initialValues() {
  return {
    nombre: getNombre(),
    apellido: getApellido(),
    email: getemail(),
    idioma: getIdioma(),
    telefono: getTelefono(),
    identificacion: getIdentificacion(),
    contactosemergencia: getContactosEmergencia(),
    avatar: getavatar().replace("uploads/", ""),
    fileAvatar: null,
  };
}

export function validationSchema() {
  return Yup.object({
    nombre: Yup.string().required(` ${campo_obligatorio} `),
    apellido: Yup.string().required(` ${campo_obligatorio} `),
    idioma: Yup.string().required(` ${campo_obligatorio} `),
    email: Yup.string()
      .email(` ${email_invalido} `)
      .required(` ${campo_obligatorio} `),
    telefono: Yup.string().required(` ${campo_obligatorio} `),
    identificacion: Yup.string().required(` ${campo_obligatorio} `),
  });
}
